// material-ui
import icon from './logo.png';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return (
    <>
      <img src={icon} alt="icon" width="50%" />
    </>
  );
}
